"use strict";

/**
 * Guide books JS file.
 */

(function ($, Drupal, drupalSettings) {
  "use strict";

  /**
   * An example of Drupal behavior syntax.
   * We should create a new behavior to wrap different functionality.
   */
  Drupal.behaviors.exampleBehavior = {
    attach: function attach(context, settings) {
      // Code goes here.
      // Relevant functions can also go inside here.
    },
  };

  Drupal.behaviors.genericTabToggle = {
    attach: function () {
      const tabButtons = $(".tab-button");

      $(tabButtons)
        .off()
        .on("click", function (e) {
          e.preventDefault();
          e.stopPropagation();

          const target = $(this)[0].getAttribute("aria-controls");
          const revealElement = $("#" + target);

          for (const button of tabButtons) {
            button.setAttribute("aria-selected", "false");
          }
          $(this)[0].setAttribute("aria-selected", "true");

          $(revealElement).siblings(".lesson-container").hide();
          $(revealElement).fadeIn();
        });
    },
  };
})(jQuery, Drupal, drupalSettings);
//# sourceMappingURL=guides.js.map
